const strawProduct = {
  variations: [
    {
      text: "Straw Bedding Pellets 975kg (£4.31/bag) Full Pallet",
      stripe_price_id: "price_1TCMqODaY5da5KQsXgbTfF43",
      //   stripe_price_id: "price_1Jf4VmDaY5da5KQspj1VKPTi", // test product
      price: "280.00",
    },
    {
      text: "Straw Bedding Pellets 750kg (£4.42/bag) Three Quarter Pallet",
      stripe_price_id: "price_1TCN2MDaY5da5KQstLAzyS3H",
      //   stripe_price_id: "price_1Jf4VmDaY5da5KQspj1VKPTi", // test product
      price: "221.00",
    },
    {
      text: "Straw Bedding Pellets 525kg (£5.26/bag) Half Pallet",
      stripe_price_id: "price_1TCN39DaY5da5KQsAsQ4OESH",
      //   stripe_price_id: "price_1Jf4VmDaY5da5KQspj1VKPTi", // test product
      price: "184.00",
    },
  ],
}
const WoodProduct = {
  variations: [
    {
      text: "Wood Bedding Pellets 975kg (£3.53/bag) Full Pallet",
      stripe_price_id: "", // add id when back in stock price_1JkVABDaY5da5KQsG312QHkb
      price: "Out of stock",
    },
    {
      text: "Wood Bedding Pellets 525kg (£3.82/bag) Half Pallet",
      stripe_price_id: "", // add id when back in stock price_1JeMinDaY5da5KQsKCO0Ayj0
      price: "Out of stock",
    },
  ],
}

export { strawProduct, WoodProduct }
